import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Stack, Typography } from '../../atoms';
import { useIsDesktop } from '../../hooks';
import { FormFlex } from '../../legacy/components';
import { useAppLinkUi } from '../../legacy/hooks';
import { styled } from '../../legacy/utils';
const menuKey = ['home', 'signOut', 'signIn', 'user', 'phone'];
export const HeaderContents = ({ contents }) => {
    const isDesktop = useIsDesktop();
    return (_jsx(FormFlex, { rowGap: 0, columnGap: isDesktop ? 108 : 106, align: "center", children: contents.map(({ text, subText, icon, onClick, link, key, loading, linkType, display, }) => (_jsx(CustomHeaderContent, { text: text, subText: subText, icon: icon, onClick: onClick, link: link, loading: loading, linkType: linkType, display: display }, key))) }));
};
// TODO: make reusable
// TODO: mobile/desktop optimization. Header should always be one line. How we keep this goal in a way without using breakpoints
const CustomHeaderContent = ({ text, subText, icon, onClick, link, loading, linkType, }) => {
    const isDesktop = useIsDesktop();
    const AppLink = useAppLinkUi();
    return (_jsxs(Stack, { flexDirection: "row", gap: 1, alignItems: "center", children: [linkType === 'AppLink' ? (_jsx(AppLink, { customIcon: icon, href: link, children: isDesktop && text })) : (_jsx(ButtonStyled, { icon: icon, variant: "text", disabled: loading, onClick: onClick, children: _jsx(Typography, { color: "darkBlue", variant: "body1 light", children: text }) })), subText && isDesktop && (_jsx(Typography, { variant: "body2 light", color: "black", children: subText }))] }));
};
const ButtonStyled = styled(Button)(({ theme }) => ({
    [theme.breakpoints.down('lg')]: {
        paddingLeft: 0,
        paddingRight: 0,
        minWidth: theme.spacing(3),
        '& .MuiTypography-root': {
            fontSize: '14px',
        },
    },
    [theme.breakpoints.down('md')]: {
        '& .MuiTypography-root': {
            display: 'none',
        },
    },
}));
